/* eslint-disable no-param-reassign */
import { Auth } from './Auth';

export default {
  /**
  * Install the plugin
  */
  install(Vue, options) {
    Vue.prototype.$auth = new Auth(options);
  },
};
